import {
    DELETE_ALL_BOOKMARKS,
    DELETE_ALL_BOOKMARKS_FAILURE,
    DELETE_ALL_BOOKMARKS_REQUEST,
    DELETE_ALL_BOOKMARKS_SUCCESS,
    GET_BOOKMARKS,
    GET_BOOKMARKS_FAILURE,
    GET_BOOKMARKS_REQUEST,
    GET_BOOKMARKS_SUCCESS,
    SET_BOOKMARK,
    SET_BOOKMARK_FAILURE,
    SET_BOOKMARK_REQUEST,
    SET_BOOKMARK_SUCCESS,
} from './constants';
import {
    Bookmark,
    BookmarkContentType,
    BookmarkTagsType,
} from './reducer.types';

export function getBookmarks() {
    return {
        type: GET_BOOKMARKS,
    };
}

export function getBookmarksRequest() {
    return {
        type: GET_BOOKMARKS_REQUEST,
    };
}

export function getBookmarksSuccess(bookmarks: Bookmark[]) {
    return {
        type: GET_BOOKMARKS_SUCCESS,
        payload: { bookmarks },
    };
}

export function getBookmarksFailure(error: any) {
    return {
        type: GET_BOOKMARKS_FAILURE,
        payload: { error },
    };
}

export function setBookmark(bookmark: {
    account: string;
    contentId: string;
    position: number;
    contentType: BookmarkContentType;
    tags: BookmarkTagsType[];
    expires?: number;
    metadata?: Record<string, any>;
}) {
    return {
        type: SET_BOOKMARK,
        payload: { bookmark },
    };
}

export function setBookmarkRequest() {
    return {
        type: SET_BOOKMARK_REQUEST,
    };
}

export function setBookmarkSuccess(bookmark: Bookmark) {
    return {
        type: SET_BOOKMARK_SUCCESS,
        payload: { bookmark },
    };
}

export function setBookmarkFailure(error: any) {
    return {
        type: SET_BOOKMARK_FAILURE,
        payload: { error },
    };
}

export function deleteAllBookmarks() {
    return {
        type: DELETE_ALL_BOOKMARKS,
    };
}

export function deleteAllBookmarksRequest() {
    return {
        type: DELETE_ALL_BOOKMARKS_REQUEST,
    };
}

export function deleteAllBookmarksSuccess() {
    return {
        type: DELETE_ALL_BOOKMARKS_SUCCESS,
    };
}

export function deleteAllBookmarksFailure(error: any) {
    return {
        type: DELETE_ALL_BOOKMARKS_FAILURE,
        payload: { error },
    };
}
